import { useSubmitCompensationChangeRequestMutation } from "types/generated/operations";
import { useNavigate } from "react-router-dom";
import EditCompensation, {
  CompensationChangeRequest,
} from "../components/EditCompensation/EditCompensation";
import { useProfileContextData } from "../contexts/ProfileInfoContext";
import { Spinner } from "@justworkshr/milo-core";
import { getEmployeeDisplayName } from "../utils";
import { useProfileRedirectUrl } from "../hooks/useProfileRedirectUrl";

export default function EditCompensationPage() {
  const navigate = useNavigate();
  const profileRedirectUrl = useProfileRedirectUrl();
  const [submitCompensationChangeRequest] =
    useSubmitCompensationChangeRequestMutation();

  const { profileInfo } = useProfileContextData();
  const displayName = getEmployeeDisplayName(
    profileInfo?.eorEmployeeProfile.personalInfo
  );

  if (!profileInfo) return <Spinner />;

  async function onSubmit(request: CompensationChangeRequest) {
    await submitCompensationChangeRequest({
      variables: request,
    });

    navigateToProfile();
  }

  function navigateToProfile() {
    const path = `${profileRedirectUrl}?updated=${encodeURIComponent(
      `Request received! We'll review ${displayName}'s contract details and get back to you soon.`
    )}`;
    navigate(path);
  }

  return <EditCompensation onSubmit={onSubmit} />;
}
